module.exports = __webpack_public_path__ + "static/media/power-off-dot.47443ace.svg";